import { render } from "./ArticleListMolecule.vue?vue&type=template&id=9c9850d0&scoped=true"
import script from "./ArticleListMolecule.vue?vue&type=script&lang=js"
export * from "./ArticleListMolecule.vue?vue&type=script&lang=js"

import "./ArticleListMolecule.vue?vue&type=style&index=0&id=9c9850d0&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9850d0"]])

export default __exports__